import articles from './articles';
import Article from './Article';

export { Article };

export default articles;
